import { createAuthClient } from 'better-auth/react'
import { twoFactorClient } from 'better-auth/client/plugins'

/**
 * BetterAuth client: sign-in, sign-up, verification, password reset and
 * two-step codes. Same origin — /api/auth is proxied to esm-api.
 * When a password sign-in needs a second factor, BetterAuth answers with
 * `twoFactorRedirect` and the plugin sends the person to /mfa.
 */
export const authClient = createAuthClient({
  baseURL: window.location.origin,
  plugins: [
    twoFactorClient({
      onTwoFactorRedirect() {
        const next = new URLSearchParams(window.location.search).get('next')
        window.location.assign(`/mfa${next ? `?next=${encodeURIComponent(next)}` : ''}`)
      },
    }),
  ],
})
